import { DataSource, Image, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiBatchHistoryQuickInfoTable extends Layout {
    imagePopOut: Image;
    labelBatchHistory: Label;
    sourceEdiBatchHistory: DataSource;
    tableBatchHistory: Table;
}
